import { dedupePreserveOrder } from './respondents';

// Lock-state resolver:
// consolidates websocket owner + other editors into UI-ready row lock metadata.

export type RowLockOwner = { userId: string; name: string };

export type RowLockState = {
  owner?: RowLockOwner;
  others: string[];
  isOwnerSelf: boolean;
  lockNames: string[];
  isLocked: boolean;
  lockedName: string;
};

type ResolveRowLockStateParams = {
  wrNum: number;
  otherEditingByWrId: Record<number, string[]>;
  lockOwnerByWrId: Record<number, RowLockOwner>;
  selfLoginId?: string;
  userName?: string;
};

export const resolveRowLockState = ({
  wrNum,
  otherEditingByWrId,
  lockOwnerByWrId,
  selfLoginId,
  userName,
}: ResolveRowLockStateParams): RowLockState => {
  const hasWrNum = Number.isFinite(wrNum);
  const others = hasWrNum ? (otherEditingByWrId[wrNum] ?? []) : [];
  const owner = hasWrNum ? lockOwnerByWrId[wrNum] : undefined;
  const ownerUserId = String(owner?.userId ?? '').trim();
  const ownerName = String(owner?.name ?? '').trim();
  const selfId = String(selfLoginId ?? '').trim();
  const selfName = String(userName ?? '').trim();
  const isOwnerSelf = (() => {
    if (!owner) return false;
    // Prefer userId match. Use name only when owner userId is missing.
    if (ownerUserId) return !!selfId && ownerUserId === selfId;
    if (ownerName) return !!selfName && ownerName === selfName;
    return false;
  })();
  const lockNames = dedupePreserveOrder(
    [...others, !isOwnerSelf && ownerName ? ownerName : ''].filter(
      (v): v is string => typeof v === 'string' && v.trim() !== ''
    )
  );
  return {
    owner,
    others,
    isOwnerSelf,
    lockNames,
    isLocked: lockNames.length > 0,
    lockedName: lockNames.join(', '),
  };
};
